/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchPermissionGrantsUserResponse } from './search-permission-grants-user-response';
import { SearchPermissionGrantPermissionResponseItem } from './search-permission-grant-permission-response-item';
import { DateTimePeriod } from './date-time-period';

export interface SearchPermissionGrantsResponseItem {
  id?: string;
  sourceUser?: SearchPermissionGrantsUserResponse;
  destinationUser?: SearchPermissionGrantsUserResponse;
  grantDates?: DateTimePeriod;
  permissions?: Array<SearchPermissionGrantPermissionResponseItem> | null;
  reason?: string | null;
}
